const moduleName = 'faq';

export function faq() {

    Array.from(document.querySelectorAll('.js-faq')).forEach((self) => {
        if (self.dataset[moduleName + 'Init'] === 'true') return;
        self.dataset[moduleName + 'Init'] = true;

        const SPEED = 300;

        const faq = self;
        const faqItems = faq.querySelectorAll('.js-faq-item');

        Array.from(faqItems).forEach((faqItem) => {
            const faqItemToggle = faqItem.querySelector('.js-faq-item-toggle');
            const faqItemBody = faqItem.querySelector('.js-faq-item-body');
            const faqItemContent = faqItem.querySelector('.js-faq-item-content');

            faqItemToggle.addEventListener('click', () => {
                if (faqItem.classList.contains('_open')) {
                    faqItemBody.style.height = faqItemBody.offsetHeight + 'px';

                    setTimeout(() => {
                        faqItemBody.style.height = 0;

                        setTimeout(() => {
                            faqItem.classList.remove('_open');
                            faqItemBody.style.height = '';
                        }, SPEED);
                    }, 20);
                } else {
                    faqItemBody.style.height = 0;

                    setTimeout(() => {
                        faqItemBody.style.height = faqItemContent.offsetHeight + 'px';

                        setTimeout(() => {
                            faqItem.classList.add('_open');
                            faqItemBody.style.height = '';
                        }, SPEED);
                    }, 20);
                }
            });
        });
    });

}